import { t } from '../../../../services/i18nService';
import imageService from '../../../../services/questionView/ImageService';

const recommendedMaxHeight = 350;

const imageSelector = {
    selectInitialStyle(useModelWidthAndHeight, questionObjectType, isInteraction, model) {
        const { width = 0, height = 0, maxHeight, orgWidth } = model;

        if (imageService.shouldUseModelSize(useModelWidthAndHeight, questionObjectType, width, height)) {
            return {
                height: `${height}px`,
                width: `${width}px`,
            };
        }

        const style = {
            height: 'auto',
        };

        if (model.originalStyle) {
            return { ...model.originalStyle, ...style };
        }

        if (width || orgWidth) {
            style.width = `${width || orgWidth}px`;
        }

        if (!isInteraction) {
            style.maxWidth = '100%';
            style.height = 'auto';
        }

        if (imageService.shouldUseRecommendedMaxHeight(maxHeight)) {
            style.maxHeight = `${recommendedMaxHeight}px`;
        }

        return style;
    },

    selectClassList(model) {
        const { isMainMedia, originalClassNames } = model;

        const classList = ['qti-image'];

        if (isMainMedia) {
            classList.push('main-media');
        }

        if (originalClassNames) {
            classList.push(...originalClassNames);
        }

        return classList.join(' ');
    },

    selectProps(ownProps) {
        const {
            isInteraction,
            model,
            questionObjectType,
            useModelWidthAndHeight,
        } = ownProps;

        const { altText, isMainMedia } = model;

        return {
            initialStyle: this.selectInitialStyle(useModelWidthAndHeight, questionObjectType, isInteraction, model),
            recommendedMaxHeight,
            classList: this.selectClassList(model),
            shouldAddAlignStyle: !!isMainMedia,
            imageAlt: altText || t('image.defaultAltText'),
        };
    },
};

export default imageSelector;
